/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
	Grid,
	Button,
	TextField,
	InputAdornment,
	IconButton
} from "@material-ui/core";
import { connect } from "react-redux";
import useStyles from "./styles";
import { Images } from "config/images";
import { Controller, useForm } from "react-hook-form";
import clsx from "clsx";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";
import { loginRequest } from "store/actions/LoginPageAction";
import { useHistory } from "react-router-dom";

const LoginPage = props => {
	const { handleLogin } = props;
	const classes = useStyles();

	const [isShow, setShow] = useState(false);
	const history = useHistory();

	const TOKEN = localStorage.getItem("token");

	if (!!TOKEN) {
		history.push("/home");
	}

	const {
		handleSubmit,
		control,
		getValues,
		formState: { errors }
	} = useForm();

	const onSubmit = data => {
		const { user, password } = data;
		const dataLogin = {
			username: user,
			password: password
		};
		handleLogin(dataLogin);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<img src={Images.icTuongan} alt="icTuongan" />
				<Grid classes={{ root: classes.nameCompany }}>
					DVKH TƯỜNG AN
				</Grid>
				<Grid classes={{ root: classes.subTitle }}>
					Vui lòng đăng nhập để trải nghiệm!
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.rootForm }}>
				<Grid classes={{ root: classes.form }}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Controller
							control={control}
							name="user"
							rules={{
								required:
									"Vui lòng nhập mã mã khách hàng hoặc SĐT"
							}}
							defaultValue={
								getValues("user") ? getValues("user") : ""
							}
							render={({ field }) => (
								<TextField
									{...field}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">
												<img
													src={Images.icUserLogin}
													alt={"icUserLogin"}
													style={{ marginLeft: 10 }}
												/>
											</InputAdornment>
										)
									}}
									className={clsx(
										classes.customInput,
										errors?.user ? classes.inputError : ""
									)}
									placeholder="Nhập mã khách hàng hoặc SĐT"
								/>
							)}
						/>
						{errors?.user && (
							<Grid classes={{ root: classes.textError }}>
								{errors.user.message}
							</Grid>
						)}
						<Controller
							control={control}
							name="password"
							rules={{
								required: "Vui lòng nhập password"
							}}
							defaultValue={
								getValues("password")
									? getValues("password")
									: ""
							}
							render={({ field }) => (
								<TextField
									{...field}
									type={isShow ? "text" : "password"}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">
												<img
													src={Images.icLockLogin}
													alt={"icLockLogin"}
													style={{ marginLeft: 10 }}
												/>
											</InputAdornment>
										),
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													aria-label="toggle password visibility"
													onClick={() =>
														setShow(!isShow)
													}
												>
													{isShow ? (
														<VisibilityIcon />
													) : (
														<VisibilityOffIcon />
													)}
												</IconButton>
											</InputAdornment>
										)
									}}
									className={clsx(
										classes.customInput,
										classes.mt15,
										errors?.password
											? classes.inputError
											: ""
									)}
									placeholder="Mật khẩu"
								/>
							)}
						/>
						{errors?.password && (
							<Grid classes={{ root: classes.textError }}>
								{errors.password.message}
							</Grid>
						)}
						<Grid classes={{ root: classes.bodyBtnSubmit }}>
							<Button
								type="submit"
								classes={{ root: classes.btnSubmit }}
							>
								Đăng nhập
							</Button>
						</Grid>
						<Grid classes={{ root: classes.btnDefault }}>
							Quên mật khẩu
						</Grid>
					</form>
				</Grid>
				<img
					src={Images.icFooterLogin}
					alt="icFooterLogin"
					className={classes.logoFooter}
				/>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		handleLogin: data => {
			dispatch(loginRequest(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
